module.exports = __webpack_public_path__ + "img/T902.b5374ccb.jpg";